<template>
  <v-container>
    <v-breadcrumbs
      class="px-0 py-2"
      :items="breadcrumbs"
    />
    <v-row>
      <v-col>
        <v-card flat>
          <v-toolbar flat>
            <v-toolbar-title>請求先詳細</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <!-- コード/請求先名 -->
            <v-row>
              <v-col cols="12" md="6">
                <div class="overline">
                  請求先コード
                </div>
                <h4>{{ billing_address.code }}</h4>
                <v-divider />
              </v-col>

              <v-col cols="12" md="6">
                <div class="overline">
                  請求先名
                </div>
                <h4>{{ billing_address.name }}</h4>
                <v-divider />
              </v-col>
            </v-row>
            <!-- /コード/請求先名 -->
            <!-- 所在地 -->
            <v-row>
              <v-col cols="12" md="12">
                <div class="overline">
                  所在地
                </div>
                <h4>〒{{ billing_address.zip_code }}&emsp;{{ billing_address.address }}&nbsp;</h4>
                <v-divider />
              </v-col>
            </v-row>
            <!-- /所在地 -->
            <!-- 電話番号/登録番号 -->
            <v-row>
              <v-col cols="12" md="6">
                <div class="overline">
                  電話番号
                </div>
                <h4>{{ billing_address.phone_number }}&nbsp;</h4>
                <v-divider />
              </v-col>

              <v-col cols="12" md="6">
                <div class="overline">
                  メモ欄
                </div>
                <h4>{{ billing_address.memo }}&nbsp;</h4>
                <v-divider />
              </v-col>
            </v-row>
            <!-- /電話番号/ メモ  -->
            <!-- 登録番号 -->
            <v-row>
              <v-col cols="12" md="6">
                <div class="overline">
                  登録番号
                </div>
                <h4>{{ billing_address.register_number }}&nbsp;</h4>
                <v-divider />
              </v-col>
            </v-row>
            <!-- /登録番号 -->
          </v-card-text>

          <v-card-title>
            <span style="color: #0074BA">締め日等</span>
          </v-card-title>

          <v-card-text>
            <!-- 会社内で請求先を共有 -->
            <v-row>
              <v-col cols="12" md="6">
                <v-checkbox
                  v-model="billing_address.use_share"
                  label="会社内で請求先を共有する"
                  disabled
                  hide-details="auto"
                  class="pa-0 ma-0"
                />
                <span v-if=" billing_address.billing_tenant_name">
                  請求先テナント: {{ billing_address.billing_tenant_name }}
                </span>
              </v-col>
            </v-row>
            <!-- /会社内で請求先を共有-->

            <!-- 締め日/支払いサイト -->
            <v-row>
              <v-col cols="12" md="6">
                <div class="overline">
                  締め日
                </div>
                <h4>{{ billing_address.close_day_type_name }}</h4>
                <v-divider />
              </v-col>

              <v-col cols="12" md="6">
                <div class="overline">
                  支払いサイト
                </div>
                <h4>{{ billing_address.payment_site_name }}</h4>
                <v-divider />
              </v-col>
            </v-row>
            <!-- /締め日/支払いサイト -->

            <!-- 入金日/入金方法 -->
            <v-row>
              <v-col cols="12" md="6">
                <div class="overline">
                  入金日
                </div>
                <h4>{{ billing_address.payment_day_type_name }}</h4>
                <v-divider />
              </v-col>

              <v-col cols="12" md="6">
                <div class="overline">
                  入金方法
                </div>
                <h4>{{ billing_address.payment_method_type_name }}</h4>
                <v-divider />
              </v-col>
            </v-row>
            <!-- /入金日/入金方法 -->

            <!-- 相殺区分/端数処理区分 -->
            <v-row>
              <v-col cols="12" md="6">
                <div class="overline">
                  相殺区分
                </div>
                <h4>{{ billing_address.counterbalance_type_name }}</h4>
                <v-divider />
              </v-col>

              <v-col cols="12" md="6">
                <div class="overline">
                  端数処理区分
                </div>
                <h4>{{ billing_address.fraction_type_name }}</h4>
                <v-divider />
              </v-col>
            </v-row>
            <!-- /相殺区分/端数処理区分 -->
          </v-card-text>

          <v-card-title>
            <span style="color: #0074BA">事業者</span>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col>
                <v-data-table
                  :headers="tableHeaders"
                  :items="filteredBillingAddressDetails"
                  :items-per-page="-1"
                  hide-default-footer
                  disable-sort
                  disable-pagination
                >
                  <template v-slot:[`item.manifest_type`]="{ item }">
                    {{ item.manifest_type | manifest_type_to_label }}
                  </template>
                  <template v-slot:[`item.address`]="{ item }">
                    <span>{{ item.address | truncate(25) }}</span>
                  </template>
                  <template v-slot:[`item.created_at`]="{item}">
                    {{ item.created_at | unix_datetime_format }}
                  </template>
                  <!-- <template v-slot:[`item.editable`]="{ item }">
                    <v-btn
                      v-if="item.can_remove"
                      icon
                      color="error"
                      @click="removeButtonClickEvent(item)"
                    >
                      <v-icon>mdi-trash-can-outline</v-icon>
                    </v-btn>
                  </template> -->
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-actions>
            <v-btn
              color="error"
              @click="deleteButtonClickEvent"
            >
              削除
            </v-btn>
            <v-spacer />
            <v-btn
              @click="cancelButtonClickEvent"
            >
              閉じる
            </v-btn>
            <v-btn
              color="primary"
              @click="editButtonClickEvent"
            >
              編集
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <confirm ref="confirm" />
  </v-container>
</template>

<script>
import {mapActions} from 'vuex'
import Confirm from "../../../../components/Confirm";

export default {
  name: 'DriverMasterBillingAddressShow',
  components: {
    Confirm
  },
  mixins: [],
  props: {},
  data() {
    return {
      breadcrumbs: [
        { text: '請求先一覧', disabled: false, to: '/driver/masters/billing_addresses', exact: true },
        { text: '請求先詳細', disabled: true, to: '' },
      ],
      tableHeaders:[
        { value: 'subscriber_number', text: '加入者番号' },
        { value: 'code', text: '事業者コード' },
        { value: 'name', text: '事業者名' },
        { value: 'address', text: '住所' },
        { value: 'manifest_type', text: 'マニフェスト区分' },
        { value: 'created_at', text: '登録日時' },
      ],
      billing_address: {},
    }
  },
  computed: {
    filteredBillingAddressDetails () {
      let returnList = []
      for (const detail of this.billing_address.billing_address_details) {
        if (!detail._destroy) {
          returnList.push(detail)
        }
      }
      return returnList
    },
  },
  watch: {},
  created() {
    this.fetchBillingAddress({ id: this.$route.params.id }).then((content) => {
      this.billing_address = content
    })
  },
  methods: {
    ...mapActions('DriverMasterBillingAddress', {
      fetchBillingAddress: 'show',
      deleteBillingAddress: 'destroy',
    }),
    cancelButtonClickEvent () {
      this.$router.push({name: 'DriverMasterBillingAddresses'})
    },
    deleteButtonClickEvent () {
      this.$refs.confirm.showDeleteConfirm().then((confirm) => {
        this.$refs.confirm.close()
        if (confirm) {
          this.deleteBillingAddress({id: this.billing_address.id }).then(() =>{
            this.$router.push({name: 'DriverMasterBillingAddresses', params: { resetPagination: true }})
          })
        }
      })
    },
    editButtonClickEvent () {
      this.$router.push({name: 'DriverMasterBillingAddressEdit', params: { id: String(this.billing_address.id) }})
    }
  }
}
</script>
